import React from 'react'
import { FormattedMessage } from 'react-intl'
import { cls } from 'utilities/dom'
import { hasValue } from 'components/profile-completion'
import { HeadingColumns } from './s'
import { Plain } from 'components/button'

export const SectionHero = ({ editable, editing, toggleEditing, children, ...props }) => {
    const className = cls([
        editing && 'editing',
        editable && 'editable'
    ])

    return (
        <HeadingColumns
            {...props}
            {...(className ? { className } : null)}>
            {children}
            {!!editable && (
                <Plain
                    className="constructive"
                    onClick={() => toggleEditing(!editing)}>
                    <FormattedMessage
                        id={editing ?
                            'action_cancel' :
                            'action_edit'
                        }
                        defaultMessage={editing ?
                            'Cancel' :
                            'Edit'
                        } />
                </Plain>
            )}
        </HeadingColumns>
    )
}

export const navigationItems = [
    {
        id: 'intro',
        fields: [
            'email',
            'phone',
            'interests',
            'funfacts',
            'birthDate'
        ]
    },
    {
        id: 'employment',
        fields: [
            'jobTitle',
            'jobDescription',
            'employmentType',
            'employmentPercentage',
            'employmentStartDate',
            'firstDayOfWork',
            'employmentEndDate',
            'lastDayOfWork',
            'employmentId'
        ]
    },
    {
        id: 'salary',
        fields: ['salary']
    },
    {
        id: 'financial',
        fields: ['bankAccount']
    },
    {
        id: 'personalia',
        fields: [
            'givenName',
            'preferredName',
            'familyName',
            'gender',
            'homeAddress',
            'nationality',
            'civilStatus',
            'dietaryRequirements'
        ]
    },
    {
        id: 'identifications',
        fields: ['identifications']
    },
    {
        id: 'children',
        fields: ['children']
    },
    {
        id: 'emergencycontacts',
        fields: ['emergencyContacts']
    },
    {
        id: 'roles',
        fields: ['roles']
    }
]

export const isFieldImportant = (profile, isMe) => field => {
    if(!isMe && !profile.completeness) {
        return null
    }

    const value = profile[field]?.value

    if(profile[field]?.completeness === 'important' && !hasValue(value) && !!profile.status?.active) {
        return { className: 'important' }
    }

    return null
}